import { render, staticRenderFns } from "./UpdateRateItem.vue?vue&type=template&id=63f3ed24&"
import script from "./UpdateRateItem.vue?vue&type=script&lang=js&"
export * from "./UpdateRateItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports